import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8h4","key":"svg-0"}],["path",{"d":"M5 8v8","key":"svg-1"}],["path",{"d":"M10 12h2m2 -2a2 2 0 0 0 -2 -2m-2 2v6","key":"svg-2"}],["path",{"d":"M14 16l-3 -4","key":"svg-3"}],["path",{"d":"M17 13v-3a2 2 0 1 1 4 0v6","key":"svg-4"}],["path",{"d":"M17 13h4","key":"svg-5"}],["path",{"d":"M3 3l18 18","key":"svg-6"}]]

const IconHttpTraceOff = createReactComponent('outline', 'http-trace-off', 'HttpTraceOff', __iconNode);

export default IconHttpTraceOff;